import { View, TouchableOpacity, Text, StatusBar } from "react-native";
import React from "react";
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import dimensions from "../../globalStyles/dimensions";
import { Colors } from "../../globalStyles/ColorConfig";
import GlobalStyles from "../../globalStyles/globalStyles";
import ModalComponent from "../ModalComponent";
import ExperienceIcons from "../../assets/Icons/ExperienceIcons";
import CustomComponent from "../../components/CustomComponent";
import ShareCard from "../../screens/ExeperienceScreens/Experience/components/cardComponents/ShareCard";
import { useNavigation } from "@react-navigation/native";

const ShareCardModal = ({
  isDialog = false,
  isVisible,
  toggleModal,
  experienceData,
  data,
  receiverName,
  isReceiverInfoEmpty,
  onShare,
  shareExperienceInChat
}: {
  isDialog?: boolean;
  isVisible: boolean;
  toggleModal: () => void;
  experienceData: any;
  data: any;
  receiverName: any;
  isReceiverInfoEmpty: any;
  onShare: any;
  shareExperienceInChat?: any
}) => {
 
  const insets = useSafeAreaInsets();
  const navigation = useNavigation()

  return (
    <ModalComponent isVisible={isVisible} toggleModal={toggleModal}>
      <View
        style={{
          height: '100%',
          width: dimensions.windowWidth,
          paddingHorizontal: dimensions.paddingHorizontal,
          backgroundColor: Colors.green10,
          paddingTop: 30,
        }}
      >
        <TouchableOpacity
          onPress={() => {
            toggleModal();
          }}
        >
          <View
            style={{
              position: "absolute",
              width: 40,
              height: 40,
              borderWidth: 0.5,
              borderColor: Colors.white10,
              borderRadius: 50,
              justifyContent: "center",
              alignContent: "center",
              right: 0,
              zIndex: 2,
            }}
          >
            <TouchableOpacity
              onPress={toggleModal}
              style={{ alignSelf: "center" }}
            >
              <ExperienceIcons.WhiteCross />
            </TouchableOpacity>
          </View>
        </TouchableOpacity>
        <View
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "20%",
          }}
        >
          <ShareCard
            image={experienceData?.data?.media?.images[0]?.url}
            imgHeight={dimensions.windowHeight / 2.5}
            statusTag={false}
            edit={true}
            data={data}
            grayImg={false}
            onPress={toggleModal}
          />

          <View
            style={{
              width: "100%",
              paddingVertical: dimensions.paddingVertical / 2,
              gap: 10
            }}
          >
            {!receiverName && (
              <TouchableOpacity 
                style={{
                  paddingVertical: 20,
                  backgroundColor: Colors.gold10,
                  borderRadius: 50,
                  flexDirection: "row",
                  paddingHorizontal: 30,
                  alignItems: "center",
                  justifyContent: 'center',
                  gap: 10
                }}
                // onPress={() => {
                //   navigation.navigate('confirm-payment',{
                //     experienceId: data
                //   })
                // }}
              >
                {/* <ExperienceIcons.LightCalendar /> */}
                <Text style={[GlobalStyles.bodyText,{
                    color: Colors.white000
                  }]}>
                    Book Now
                </Text>
              </TouchableOpacity>
            )}
            <TouchableOpacity 
              style={{
                paddingVertical: 20,
                backgroundColor: 'transparent',
                borderRadius: 50,
                flexDirection: "row",
                paddingHorizontal: 30,
                alignItems: "center",
                justifyContent: 'center',
                gap: 10,
                borderWidth: 1,
                borderColor: Colors.gold10
              }}
              onPress={() => {
                if (isReceiverInfoEmpty) {
                  onShare();
                } else {
                  shareExperienceInChat();
                }
              }}
            >
              <ExperienceIcons.ShareIcon />
              <Text style={[GlobalStyles.bodyText,{
                color: Colors.white000
              }]}>
                {
                  isReceiverInfoEmpty
                    ? `Share Experience`
                    : `Share with ${receiverName}`
                }
             </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </ModalComponent>
  );
};

export default ShareCardModal;